import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleAppointment from '../../components/Appointment/SingleAppointment';

const Appointment = () => {
  return (
    <div id="it-appointment" className="it-appoinment-area pt-110 pb-110">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <SectionTitle
              itemClass="it-appoinment-title-box text-center mb-65"
              subTitleClass="it-section-subtitle"
              subTitle="WORKING HOURS"
              titleClass="it-section-title"
              title="Find The Hours That Suits You"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="it-appointment-main-box">
              <table className="it-appointment-box">
                <thead>
                  <tr className="it-appointment-weekly-name">
                    <th></th>
                    <th>Sunday</th>
                    <th>Monday</th>
                    <th>Wednesday</th>
                    <th>Thursday</th>
                    <th>Saturday</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="it-appointment-time">1:00 am</td>
                    <td className="it-appointment-item" rowSpan="2" colSpan="1">
                      <SingleAppointment
                        title="Laboratory"
                        startTime="1:00 am"
                        endTime="3:00 am"
                        description="Medical Scanne"
                      />
                    </td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                  </tr>
                  <tr>
                    <td className="it-appointment-time">2:00 am</td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                  </tr>
                  <tr>
                    <td className="it-appointment-time">7:00 am</td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td className="it-appointment-item" colSpan="1" rowSpan="2">
                      <SingleAppointment
                        title="Laboratory"
                        startTime="3:00 pm"
                        endTime="5:00 pm"
                        description="Bariatric Surgery"
                      />
                    </td>
                    <td colSpan="1"></td>
                    <td className="it-appointment-item" colSpan="1" rowSpan="2">
                      <SingleAppointment
                        title="Clinic"
                        startTime="7:00 am"
                        endTime="9:00 am"
                        description="Remote Operations"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="it-appointment-time">8:00 am</td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                  </tr>
                  <tr>
                    <td className="it-appointment-time">3:00 pm</td>
                    <td className="it-appointment-item" colSpan="1" rowSpan="2">
                      <SingleAppointment
                        title="Laboratory"
                        startTime="3:00 pm"
                        endTime="5:00 pm"
                        description="Bariatric Surgery"
                      />
                    </td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td className="it-appointment-item" colSpan="1" rowSpan="2">
                      <SingleAppointment
                        title="Laboratory"
                        startTime="3:00 pm"
                        endTime="5:00 pm"
                        description="Bariatric Surgery"
                      />
                    </td>
                    <td colSpan="1"></td>
                  </tr>
                  <tr>
                    <td className="it-appointment-time">4:00 pm</td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                  </tr>
                  <tr>
                    <td>6:00 pm</td>
                    <td colSpan="1"> </td>
                    <td className="it-appointment-item" colSpan="1" rowSpan="3">
                      <SingleAppointment
                        title="Surgery"
                        startTime="6:00 pm"
                        endTime="8:00 pm"
                        description="Bariatric Surgery"
                      />
                    </td>
                    <td className="it-appointment-item" colSpan="1" rowSpan="2">
                      <SingleAppointment
                        title="Gynecological"
                        startTime="6:00 pm"
                        endTime="7:00 pm"
                        description="Modern Medicine"
                      />
                    </td>
                    <td colSpan="1"></td>
                    <td className="it-appointment-item" colSpan="1" rowSpan="2">
                      <SingleAppointment
                        title="Cardiology"
                        startTime="6:00 pm"
                        endTime="7:00 pm"
                        description="Cardiology"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="it-appointment-time">7:00 pm</td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                  </tr>
                  <tr>
                    <td className="it-appointment-time">8:00 pm</td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                    <td colSpan="1"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Appointment;
